(function () {
  'use strict';

  function closeMenu(menu) {
    if (menu && menu.open) menu.removeAttribute('open');
  }

  function setupDesktopNavigation(root) {
    if (root.dataset.tccNavigationReady === 'true') return;
    root.dataset.tccNavigationReady = 'true';

    var menus = Array.prototype.slice.call(root.querySelectorAll('.tcc-mega-menu'));
    var closeTimer;

    function openMenu(menu) {
      window.clearTimeout(closeTimer);
      menus.forEach(function (otherMenu) {
        if (otherMenu !== menu) closeMenu(otherMenu);
      });
      menu.setAttribute('open', '');
    }

    function scheduleClose(menu) {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(function () { closeMenu(menu); }, 180);
    }

    menus.forEach(function (menu) {
      menu.addEventListener('mouseenter', function () { openMenu(menu); });
      menu.addEventListener('mouseleave', function () { scheduleClose(menu); });
      menu.addEventListener('focusin', function () { openMenu(menu); });
      menu.addEventListener('focusout', function (event) {
        if (!menu.contains(event.relatedTarget)) scheduleClose(menu);
      });

      menu.addEventListener('toggle', function () {
        if (!menu.open) return;
        menus.forEach(function (otherMenu) {
          if (otherMenu !== menu) closeMenu(otherMenu);
        });
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) menus.forEach(closeMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') menus.forEach(closeMenu);
    });
  }

  function init(scope) {
    scope.querySelectorAll('.tcc-desktop-nav').forEach(setupDesktopNavigation);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
}());
